function SvgTermsAndConditions(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={19.105} height={25.66} {...props}>
      <defs>
        <style>{`.terms_and_conditions_svg__cls-1{fill:${props.fill}}`}</style>
      </defs>
      <g
        id="terms_and_conditions_svg__Terms_and_conditions"
        data-name="Terms and conditions"
        transform="translate(-51.988 -.001)">
        <g
          id="terms_and_conditions_svg__Group_2648"
          data-name="Group 2648"
          transform="translate(51.988 .001)">
          <g id="terms_and_conditions_svg__Group_2647" data-name="Group 2647">
            <path
              id="terms_and_conditions_svg__Path_5635"
              data-name="Path 5635"
              className="terms_and_conditions_svg__cls-1"
              d="M144.149 1.945h-1.877a.527.527 0 01-.494-.4A1.91 1.91 0 00139.834 0a1.943 1.943 0 00-1.943 1.581.494.494 0 01-.494.362h-1.812v3.296h8.564z"
              transform="translate(-130.315 -.001)"
            />
            <path
              id="terms_and_conditions_svg__Path_5636"
              data-name="Path 5636"
              className="terms_and_conditions_svg__cls-1"
              d="M71.092 82.36V63.487a1.35 1.35 0 00-1.347-1.354H66.81v1.68c0 .264-.165.626-.428.626h-9.717c-.264 0-.4-.362-.4-.626v-1.68h-2.827a1.35 1.35 0 00-1.446 1.248V82.36a1.482 1.482 0 001.449 1.515h16.202a1.482 1.482 0 001.449-1.514zm-12.22-4.348l-2.569 2.4a.461.461 0 01-.329.165.527.527 0 01-.362-.165l-1.35-1.383a.5.5 0 01.725-.692l.988 1.054 2.24-2.108a.494.494 0 01.659.725zm0-5.27l-2.569 2.4a.461.461 0 01-.329.165.527.527 0 01-.362-.165l-1.35-1.383a.5.5 0 01.725-.692l.988 1.054 2.24-2.108a.494.494 0 01.659.725zm0-5.27l-2.569 2.4a.461.461 0 01-.329.165.527.527 0 01-.362-.165l-1.35-1.383a.5.5 0 01.725-.692l.988 1.054 2.24-2.108a.494.494 0 01.659.725zm9.585 12.45h-7.576a.494.494 0 010-.988h7.576a.494.494 0 010 .988zm0-5.27h-7.576a.494.494 0 010-.988h7.576a.494.494 0 010 .988zm0-5.27h-7.576a.494.494 0 010-.988h7.576a.494.494 0 010 .988z"
              transform="translate(-51.988 -58.215)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgTermsAndConditions;
